import { useLayoutEffect } from 'react';
import { NEURAL_SCENE_REVISION } from '../constants';
import { setupNeuralScene } from '../setupNeuralScene';

export function useNeuralScene({
  graphRef,
  hostRef,
  floatingCardWrapRef,
  focusMissionRef,
  neuralSceneApiRef,
  setSelectedMissionIdRef,
  selectedMissionIdRef,
  renameTagRef,
}) {
  // Tear down before the browser's next frame. A normal effect runs too late:
  // the canvas is already gone, and one more draw of it kills the window.
  useLayoutEffect(() => {
    const container = hostRef.current;
    if (!container) return undefined;

    return setupNeuralScene({
      container,
      graphRef,
      floatingCardWrapRef,
      focusMissionRef,
      neuralSceneApiRef,
      setSelectedMissionIdRef,
      selectedMissionIdRef,
      renameTagRef,
    });
  // graph updates flow through graphRef + ensureGraphSynced in tick
  }, [setupNeuralScene, NEURAL_SCENE_REVISION]);
}
